import React from 'react';
import Interweave from 'interweave';
import { connect } from 'react-redux';
import * as StyledContactUs from './contactUs.styles';
import {
	Container, Columns,
	A
} from '../../components/base';
import pageWrapper from '../../hoc/pageWrapper';
import useOnMount from '../../hooks/useOnMount';
import { fetchPageSettings } from '../../actions/pageActions';

const ContactUs = ({
	page,
	dispatch,
	pageSettingsReducer
}) => {
	const { settings, loading, error } = pageSettingsReducer;

	useOnMount(() => {
		if(settings === null && !loading && !error) {
			dispatch(fetchPageSettings());
		}
	});


	return (
		<StyledContactUs.Wrapper>
			<Container>
				<StyledContactUs.Title>{page.Values.Title}</StyledContactUs.Title>
				<Columns>
					<StyledContactUs.ContentColumn tablet={8 / 12}>
						<StyledContactUs.Content>
							<StyledContactUs.Text>
								<Interweave content={page.Values.Content} />
							</StyledContactUs.Text>
						</StyledContactUs.Content>
						{
							settings !== null && (
								<StyledContactUs.SettingsContent>
									<StyledContactUs.Addresses>
										{
											settings.Values.Locations.map(item => (
												<StyledContactUs.Address key={item.Name}>
													<span>{item.Values.Address}</span>
													<span>,</span>
													<span>{item.Values.Zip}</span>
													<span>{item.Values.City}</span>
												</StyledContactUs.Address>
											))
										}
									</StyledContactUs.Addresses>
									<StyledContactUs.Info>
										<StyledContactUs.InfoLine>
											<div>Sími:</div>
											<A href={`tel:${settings.Values.CompanyTel}`}>
												{settings.Values.CompanyTel}
											</A>
										</StyledContactUs.InfoLine>
										<StyledContactUs.InfoLine>
											<div>Netfang:</div>
											<A href={`mailto:${settings.Values.CompanyEmail}`}>
												{settings.Values.CompanyEmail}
											</A>
										</StyledContactUs.InfoLine>
										<StyledContactUs.InfoLine>
											<div>Afgreiðslutími</div>
											<div>{settings.Values.CompanyOpeningHours}</div>
										</StyledContactUs.InfoLine>
									</StyledContactUs.Info>
								</StyledContactUs.SettingsContent>
							)
						}
					</StyledContactUs.ContentColumn>
					<StyledContactUs.ImageColumn tablet={4 / 12}>
						<StyledContactUs.Image
							image={page.Values.Image.Src}
							tabletWidth="400"
							tabletHeight="800"
							desktopWidth="500"
							desktopHeight="700"
							retinaWidth="1000"
							retinaHeight="1400" />
					</StyledContactUs.ImageColumn>
				</Columns>
			</Container>
		</StyledContactUs.Wrapper>
	);
};

const mapStateToProps = ({ pageSettingsReducer }) => ({
	pageSettingsReducer
});

export default connect(mapStateToProps)(pageWrapper(ContactUs));
